import styled from 'styled-components';
const BreadCrumbList = styled.ul`
  position: relative;
  list-style: none;
  display: flex;
  padding: 0;
  margin: 0;
  &:after {
    position: absolute;
    content: '';
    height: 2px;
    bottom: 0px;
    margin: 0 auto;
    left: 0;
    right: 0;
    width: 100%;
    background: #ccc;
  }
  &.menu1 {
    width: 70%;
  }
  &.menu2 {
    width: 30%;
    justify-content: flex-end;
  }
`;
const BreadCrumbLi = styled.li`
  text-decoration: none;
  position: relative;
  height: 100%;
  color: #ccc;
  padding: 15px;
  padding-bottom: 0;
  z-index: 3;
  font-size: 1.5rem;
  &:hover {
    cursor: pointer;
    color: #707070;
  }
  &:after {
    position: absolute;
    content: '';
    height: 2px;
    bottom: 0px;
    margin: 0 auto;
    left: 0;
    right: 0;
    width: 100%;
    background: #ccc;
  }
  &:hover:after {
    background: #707070;
  }
  &.li-selected {
    color: #707070;
    &:after {
      background: #707070;
    }
  }
`;
export { BreadCrumbLi, BreadCrumbList };